




















































































































import { Vue, Component, Mixins } from "vue-property-decorator";
import Search from "@/components/elements/utility/Search.vue";
import DataTable from "@/components/elements/utility/Table.vue";
import OrderService from "@/services/order_service";
import CustomerService from "@/services/customer_service";
import { LineItem, Order } from "@/models/order/order";
import { makeTitleCase } from "@/utility/helpers";
import { OrderStatus } from "@/models/order/helpers";
import { Customer } from "@/models/customer/customer";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import ConfirmNewQuote from "@/components/elements/modal/ConfirmNewQuote.vue";
import { OrderMixin } from "@/mixins/orders/mixin";
import { Mobile } from "@/mixins/mobile";
import ConfirmClearAll from "@/components/elements/modal/ConfirmClearAll.vue";
import { GlobalActions } from "@/store/modules/global/types";

@Component({
  components: {
    Search,
    DataTable,
    ConfirmNewQuote,
    ConfirmClearAll,
  },
})
export default class CustomerOrders extends Mixins(Mobile, OrderMixin) {
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  resetOrder!: () => Promise<void>;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: number) => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.AssignCustomer))
  assignCustomer!: (value: {
    customer_id: string;
    customer_name: string;
    order_id: string | null;
  }) => Promise<void>;
  private search = "";
  protected makeTitleCase = makeTitleCase;
  protected orderStatus = OrderStatus;
  protected orderService = new OrderService();
  protected customerService = new CustomerService();
  protected orders: Order[] = [];
  protected customer: Customer = {} as Customer;
  protected id = "";
  protected loader: any = null;
  protected showModalNew = false;

  async created() {
    this.showLoader();
    if (this.$route.params.id) {
      this.id = this.$route.params.id as string;
      this.orders = await this.orderService.getCustomerOrders(this.id);
      this.customer = await this.customerService.getSingleCustomer(this.id);
      this.closeLoader();
    } else {
      this.closeLoader();
      this.$router.replace("/customers");
    }
  }

  protected closeModal(): void {
    this.showModalNew = false;
  }

  protected async clearOrder(): Promise<void> {
    await this.resetOrder();
    await this.reassignQuote();
  }

  protected toggleNewQuoteModal(
    customerId: string,
    customerName: string,
    customerMultiplier: number
  ): void {
    if (this.items.length > 0) {
      // only toggling warning modal if there is an item associated with the order
      this.showModalNew = true;
    } else {
      this.reassignQuote();
    }
  }

  protected async reassignQuote() {
    await this.assignCustomer({
      customer_id: this.id,
      customer_name: this.customer.customer_name,
      order_id: null,
    });
    this.addMultiplier(this.customer.multiplier);
    this.close();
    this.$router.push("/");
  }

  protected showLoader(): void {
    this.loader = this.$loading.show({
      opacity: 1,
    });
  }

  protected closeLoader(): void {
    setTimeout(() => {
      this.loader.hide();
    }, 300);
  }

  // Triggered from child component, <Search />
  protected submitSearch(searchTerm: string): void {
    this.search = searchTerm;
  }

  protected getItems(items: LineItem[]): number {
    let num = 0;
    for (const item of items) {
      num = num + item.qty;
    }
    return num;
  }

  protected getTotal(items: LineItem[]): number {
    let num = 0;
    for (const item of items) {
      num = num + item.qty * item.unit_price * item.multiplier;
    }
    return num;
  }

  get filteredOrders() {
    let orders = this.orders.slice().sort(function(a, b) {
      //@ts-ignore
      return (new Date(b.created_at) as any) - (new Date(a.created_at) as any);
    });
    orders = orders.filter((o) => o.status !== OrderStatus.Converted);
    if (this.search != "") {
      const filter = (orders as any[]).filter((item) => {
        return (
          item.contact_details.quote_name
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1
        );
      });
      return filter;
    } else {
      return orders;
    }
  }
}
